var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanityContent = exports.sanitySerializers = exports.renderCode = void 0;

var react_1 = __importDefault(require("react"));

var html_react_parser_1 = __importDefault(require("html-react-parser"));

var node_1 = require("domhandler/lib/node");

var block_content_to_react_1 = __importDefault(require("@sanity/block-content-to-react"));

var gatsby_1 = require("gatsby");

var renderCode = function renderCode(html) {
  var elementId = Math.random().toString(36).substring(9);
  return (0, html_react_parser_1.default)(html, {
    replace: function replace(domNode) {
      if (domNode instanceof node_1.Element && domNode.attribs) {
        if (domNode.type === "script") {
          var script = document.createElement("script");
          if (domNode.attribs.src) script.src = domNode.attribs.src; // @ts-ignore

          if (domNode.children.length) script.innerHTML = domNode.children[0].data;
          script.id = "code-".concat(elementId);
          script.className = "code-".concat(elementId);
          script.type = "text/javascript";
          script.async = true;
          script.defer = true;
          document.body.prepend(script);
          return react_1.default.createElement(react_1.default.Fragment, {
            key: elementId
          });
        }
      }

      return domNode;
    }
  });
};

exports.renderCode = renderCode;
var serializers = {
  marks: {
    document: function document(_ref) {
      var children = _ref.children,
          mark = _ref.mark;

      var _a, _b;

      return react_1.default.createElement(gatsby_1.Link, {
        to: ((_a = mark === null || mark === void 0 ? void 0 : mark.document) === null || _a === void 0 ? void 0 : _a.link) || "",
        title: (_b = mark === null || mark === void 0 ? void 0 : mark.document) === null || _b === void 0 ? void 0 : _b.title
      }, children);
    },
    link: function link(_ref2) {
      var children = _ref2.children,
          mark = _ref2.mark;

      var _a, _b, _c;

      return react_1.default.createElement("a", {
        href: (_a = mark === null || mark === void 0 ? void 0 : mark.link) === null || _a === void 0 ? void 0 : _a.link,
        title: (_b = mark === null || mark === void 0 ? void 0 : mark.link) === null || _b === void 0 ? void 0 : _b.title,
        target: ((_c = mark === null || mark === void 0 ? void 0 : mark.link) === null || _c === void 0 ? void 0 : _c.external) ? "_blank" : ""
      }, children);
    },
    color: function color(_ref3) {
      var children = _ref3.children,
          mark = _ref3.mark;
      return react_1.default.createElement("span", {
        style: {
          color: mark === null || mark === void 0 ? void 0 : mark.hex
        }
      }, children);
    }
  },
  types: {
    code: function code(_ref4) {
      var node = _ref4.node;
      return (0, exports.renderCode)(node.code);
    },
    image: function image(_ref5) {
      var node = _ref5.node;

      var _a;

      return react_1.default.createElement("img", {
        src: (_a = node === null || node === void 0 ? void 0 : node.asset) === null || _a === void 0 ? void 0 : _a.url
      });
    },
    customImage: function customImage(_ref6) {
      var node = _ref6.node;

      var _a;

      return react_1.default.createElement("img", {
        alt: node === null || node === void 0 ? void 0 : node.alt,
        src: (_a = node === null || node === void 0 ? void 0 : node.asset) === null || _a === void 0 ? void 0 : _a.url
      });
    }
  }
};

var sanitySerializers = function sanitySerializers(customSerializers) {
  return {
    marks: Object.assign(Object.assign({}, serializers === null || serializers === void 0 ? void 0 : serializers.marks), (customSerializers === null || customSerializers === void 0 ? void 0 : customSerializers.marks) || {}),
    types: Object.assign(Object.assign({}, serializers === null || serializers === void 0 ? void 0 : serializers.types), (customSerializers === null || customSerializers === void 0 ? void 0 : customSerializers.types) || {})
  };
};

exports.sanitySerializers = sanitySerializers;

var sanityContent = function sanityContent(content) {
  var customSerializers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return content ? react_1.default.createElement(block_content_to_react_1.default, {
    className: "rte",
    blocks: content,
    serializers: customSerializers || serializers
  }) : content;
};

exports.sanityContent = sanityContent;